enum IncomeVerificationIncomeSourceFreelanceDocumentEnum {
    AnnualStatement = 'annualStatement',
    CertifiedChamberOfCommerceExtract = 'certifiedChamberOfCommerceExtract',
    TaxReturn = 'taxReturn',
}

export default IncomeVerificationIncomeSourceFreelanceDocumentEnum;
